module.exports = __webpack_public_path__ + "img/sociesc.8821bcd5.svg";